import { render, staticRenderFns } from "./SendIndications.vue?vue&type=template&id=f70796a2&scoped=true&"
import script from "./SendIndications.vue?vue&type=script&lang=js&"
export * from "./SendIndications.vue?vue&type=script&lang=js&"
import style0 from "./SendIndications.vue?vue&type=style&index=0&id=f70796a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70796a2",
  null
  
)

export default component.exports